import { FormattedMessage } from 'react-intl';
import React from 'react';

const FormattedMessages = {
  CompleteSMSTitleText: (
    <FormattedMessage
      id="Home.CompleteSMSTitleText"
      defaultMessage="Send SMS"
    />
  ),
  webSMSText: (
    <FormattedMessage
      id="Home.WebSMSText"
      defaultMessage="Manage your list of recipients and distributions."
    />
  ),
  manageText: <FormattedMessage id="Home.ManageLink" defaultMessage="Manage" />,
  templatesTitleText: (
    <FormattedMessage id="Home.TemplatesTitleText" defaultMessage="Templates" />
  ),
  templatesText: (
    <FormattedMessage
      id="Home.TemplatesText"
      defaultMessage="View SMS Templates list"
    />
  ),
  composeTitleText: (
    <FormattedMessage id="Home.ComposeTitleText" defaultMessage="Compose SMS" />
  ),
  composeText: (
    <FormattedMessage
      id="Home.ComposeText"
      defaultMessage="Compose a new SMS"
    />
  ),
  reportsTitleText: (
    <FormattedMessage id="Home.ReportsTitleText" defaultMessage="Reports" />
  ),
  reportsText: (
    <FormattedMessage
      id="Home.ReportsText"
      defaultMessage="View reports for cost centres and users."
    />
  ),
  viewText: <FormattedMessage id="Home.ViewLink" defaultMessage="View" />,
  accountTitleText: (
    <FormattedMessage id="Home.AccountTitleText" defaultMessage="Account" />
  ),
  accountText: (
    <FormattedMessage
      id="Home.AccountText"
      defaultMessage="Update your subscription &amp; plan and view invoices."
    />
  ),
  welcomeText: (
    <FormattedMessage id="Home.WelcomeText" defaultMessage="Welcome back" />
  ),
  dedicatedNumbers: (
    <FormattedMessage
      id="AdminProvider.DedicatedNumbers"
      defaultMessage="Dedicated Numbers"
    />
  ),
  announcements: (
    <FormattedMessage id="Home.Announcements" defaultMessage="Announcements" />
  ),
  messageBalance: (
    <FormattedMessage
      id="Home.MessageBalance"
      defaultMessage="Message Balance"
    />
  ),
  user: <FormattedMessage id="Websms.User" defaultMessage="User" />,
  topError: <FormattedMessage id="Home.TopError" defaultMessage="Top Errors" />,
  smsTraffic: (
    <FormattedMessage id="Home.SmsTraffic" defaultMessage="SMS Traffic" />
  ),
  topUsers: (
    <FormattedMessage id="Home.TopUsers" defaultMessage="Top 5 Users" />
  ),
  invoices: <FormattedMessage id="Home.Invoices" defaultMessage="Invoices" />,
  tenDlcCampaigns: (
    <FormattedMessage
      id="Home.TenDlcCampaigns"
      defaultMessage="10DLC Campaigns"
    />
  ),
  messageFailedDeliveryRoutes: (
    <FormattedMessage
      id="Home.MessageFailedDeliveryRoutes"
      defaultMessage="Message Failed Delivery - Routes"
    />
  ),
  messageDeliveryRates: (
    <FormattedMessage
      id="Home.MessageDeliveryRates"
      defaultMessage="Message Delivery Rates"
    />
  ),
  errorsByCode: (
    <FormattedMessage id="Home.ErrorsByCode" defaultMessage="Errors by Code" />
  ),
  messageLatencyAverage: (
    <FormattedMessage
      id="Home.messageLatency"
      defaultMessage="Message Latency (Average)"
    />
  ),
  errorsByTopCustomers: (
    <FormattedMessage
      id="Home.errorsByTopCustomers"
      defaultMessage="Errors by Top Customers"
    />
  ),
  last24Hours: (
    <FormattedMessage id="Home.last24Hours" defaultMessage="Last 24 Hours" />
  ),
  noDataAvailable: (
    <FormattedMessage
      id="Home.noDataAvailable"
      defaultMessage="No Data Available"
    />
  ),
  messageRemaining: (
    <FormattedMessage
      id="Websms.MessageRemaining"
      defaultMessage="User Messages Remaining"
    ></FormattedMessage>
  ),
  creditsRemaining: (
    <FormattedMessage
      id="Websms.CreditsRemaining"
      defaultMessage="Account Credits Remaining"
    ></FormattedMessage>
  ),
  creditBalance: (
    <FormattedMessage
      id="Websms.CreditBalance"
      defaultMessage="Credit Balance"
    ></FormattedMessage>
  ),
};

export default FormattedMessages;
